module.exports = __webpack_public_path__ + "img/Priest-nightelf-m-60.6ea4fff3.gif";